import React from 'react';
import './index.scss';
const RandomError = () => (
  <div className='random-error'>
    <div className='background-dark' />
    <div className='main-container'>
      <div className='random-error-container '>
        <div className='title'>Что-то пошло не так :{'('}</div>
        <div className='description'>
          Мы уже получили сообщение об ошибке и скоро исправим её. Если ошибка
          повторяется, свяжитесь с нами по телефону:
          <span className='bold'> +7 495 640 9 640 </span>
        </div>
        <div className='description'>
          Попробуйте перезагрузить страницу или вернуться на главную.
        </div>
        <div className='wrap'>
          <button
            onClick={() => location.reload()}
            className=' button button-green'
          >
            {' '}
            Перезагрузить
          </button>
          <a href='/'>
            <button className='button'> На главную </button>
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default RandomError;
